<template>
<div class="attention-box-ui" v-if="isAttentionBox">
    <div class="attention-container" :style="{'background':'url('+mallQrCode.bgImage+')'}">
        <div class="attention-info" :style="{'text-align':mallQrCode.textPosition}">
            <div class="attention-name" v-if="mallQrCode.name">{{mallQrCode.name}}</div>
            <div class="public-code-desc">
                长按识别关注 随时查看订单
            </div>
        </div>

        <div class="describeInfo">
            <img :src="wxImg" >
        </div>

        <div class="tips" @click="isTipsQr()"><i class="iconfont" :class="{'iconyixuanze':tips}"></i>不再提醒</div>
        <div v-if="officialAccountCountdown=='T'" class="timeOut">弹窗将在{{timeOut}}秒后自动关闭</div>
        <span class="iconfont iconshanchu1" @click="isShowAttentionBox()"></span>
    </div>

</div>
</template>

<script>
import api from "@/utils/api";
import {
    jAlert3
} from "@/base/jAlert/jAlert";
import {
    setStorage,
    getStorage,
} from "@/utils/wxuser";
export default {
    data() {
        return {
            wxuser: getStorage("wxuser"),
            isAttentionBox: false,
            closeAccountQrcode: 'F', //关闭二维码弹窗
            timeOut: 10,
            officialAccountCountdown: "F",
            tips: false,
            wxImg: '',
            mallQrCode: {
                show: 'F',
                describeInfo: '',
                itemValue: ''
            },
        }
    },
    methods: {
        isShowAttentionBox() {
            this.isAttentionBox = !this.isAttentionBox
            if (this.tips) {
                setStorage('closeQrCode', true)
            }
        },
        isTipsQr() {
            this.tips = !this.tips
        },
        batchQueryShopConfig(cb) {
            var opt = {
                hotelGroupCode: config.hotelGroupCode,
                hotelCode: config.hotelCode,
                configItem: "closeAccountQrcode,official_account_countdown",
            };

            api.batchQueryShopConfig(opt).then((res) => {
                res.retVal.forEach((item) => {
                    if (item.configItem == 'official_account_countdown') {
                        if (item.itemValue == "T") {
                            this.officialAccountCountdown = 'T';
                        }
                    }
                    if (item.configItem == "closeAccountQrcode") {
                        if (item.itemValue) {

                            try {
                                var mallQrCodeode = JSON.parse(item.itemValue)

                                if (mallQrCodeode.codeStyle == '1') {
                                    this.mallQrCode.textPosition = 'center'
                                    this.mallQrCode.bgImage = 'https://xcx.ihotel.cn/mall-chain/attention-bg1.png'
                                }
                                if (mallQrCodeode.codeStyle == '2') {
                                    this.mallQrCode.textPosition = 'left'
                                    this.mallQrCode.bgImage = 'https://xcx.ihotel.cn/mall-chain/attention-bg2.png'

                                }
                                if (mallQrCodeode.codeStyle == '3') {
                                    this.mallQrCode.textPosition = 'right'
                                    this.mallQrCode.bgImage = 'https://xcx.ihotel.cn/mall-chain/attention-bg3.png'

                                }
                                if (mallQrCodeode.codeStyle == 'diy') {
                                    this.mallQrCode.textPosition = mallQrCodeode.textPosition
                                    this.mallQrCode.bgImage = mallQrCodeode.bgImage
                                }
                                this.mallQrCode.name = mallQrCodeode.name
                                this.mallQrCode.describeInfo = item.describeInfo
                                this.mallQrCode.itemValue = mallQrCodeode.closeAccountQrcode

                            } catch (error) {
                                this.mallQrCode.describeInfo = item.describeInfo
                                this.mallQrCode.itemValue = item.itemValue
                            }
                            this.closeAccountQrcode = this.mallQrCode.itemValue
                            if (!getStorage('closeQrCode') && this.closeAccountQrcode != 'T') {
                                this.getWechatAccountInf()
                            }
                        }
                        
                    }
                })
            })
        },
        getWechatAccountInf() {

            try {
                var opt = {
                    openid: this.wxuser.openid,
                    appid: config.appid,
                    componentAppid: config.componentAppid
                }
                api.getWxUser(opt).then(res => {
                    if (res.result == 1) {
                        
                        if (res.retVal.subscribe == undefined || res.retVal.subscribe != "1") {
                            api.wechatAccountInf(opt).then(res => {

                                if (res.result == 1) {
                                    this.officialName = res.retVal.name
                                    this.wxImg = "https://open.weixin.qq.com/qr/code?username=" + res.retVal.accountId
                                    this.isAttentionBox = true
                                    if (this.officialAccountCountdown == 'T') {
                                        var timer = setInterval(() => {
                                            this.timeOut--;
                                            if (this.timeOut <= 0) {
                                                this.isAttentionBox = false
                                                clearInterval(timer)
                                            }
                                        }, 1000)
                                    }

                                }
                            });
                        }
                    }
                });

            } catch (error) {

            }

        },
    },
    mounted() {
        this.batchQueryShopConfig(() => {
            if (!getStorage('closeQrCode') && this.closeAccountQrcode != 'T') {
                this.getWechatAccountInf()
            }
        });
    }
}
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.attention-box-ui {
    position: fixed;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 999;

    .attention-container {
        position: absolute;
        left: 6.67%;
        top: 50%;
        margin-top: -30px;
        background: #fff;
        border-radius: 20px;
        text-align: center;
        padding: 0.533333rem 0;
        width: 8.666667rem;
        transform: translateY(-50%);
        background-size: cover !important;

        .attention-info {
            width: 6rem;
            margin: 0 auto;
        }

        .attention-name {
            font-family: PingFangSC-Semibold;
            font-size: 22px;
            color: #333333;
            font-weight: 600;
            line-height: 1.4;
        }

        .public-code-desc {
            margin-top: 8px;
            font-size: 14px;
            color: #333333;
            line-height: 1.4;
        }

        .describeInfo {
            padding: 0.533333rem 0;
        }

        /deep/ img {
            width: 6rem;
            height: 6rem;
            border-radius: 0.426667rem;
        }

        .tips {

            display: flex;
            align-items: center;
            font-size: 14px;
            color: #333;
            justify-content: center;

            i {
                border: 1px solid #999;
                width: 14px;
                height: 14px;
                font-size: 14px;
                box-sizing: border-box;
                color: #666;
                margin-right: 0.186667rem;
                border-radius: 2px;

                &.iconyixuanze {
                    border: 0;
                }
            }
        }
        .timeOut{
            margin-top: 0.266667rem;
        }
        .iconshanchu1 {
            color: #fff;
            position: absolute;
            bottom: -1.733333rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 35px;
            background: rgba(255, 255, 255, 0.25);
            border-radius: 50%;
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/components/officialAccount.vue